import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { isEqual } from 'lodash-es';
import { RefObject } from 'react';
import PromptResults from 'routes/smart-quote/components/prompt-results';
import ParsingBadge from 'routes/smart-quote/components/prompt-results/components/parsing-badge/parsing-badge';
import PromptSummary from 'routes/smart-quote/components/prompt-summary';
import { getTabPromptsIds } from 'state/workspaces/smart-quote/selectors';

type SmartQuoteMainProps = {
  pageRef: RefObject<HTMLDivElement | null>;
};

export const SmartQuoteMain = ({ pageRef }: SmartQuoteMainProps) => {
  const tabId = useAssertedActiveTabId();
  const promptsIds = useAppSelector(state => getTabPromptsIds(state, tabId), isEqual);

  if (promptsIds.length === 0) {
    return null;
  }

  return (
    <div className="flex-y flex-grow-1 gap-64px pb-64px">
      {promptsIds.map(promptId => (
        <PromptItem key={promptId} promptId={promptId} pageRef={pageRef} />
      ))}
    </div>
  );
};

const PromptItem = function PromptItem({
  promptId,
  pageRef,
}: {
  promptId: string;
  pageRef: RefObject<HTMLDivElement | null>;
}) {
  return (
    <div className="flex-y gap-64px">
      <PromptSummary promptId={promptId} />
      <div className="flex-y gap-2">
        <ParsingBadge promptId={promptId} />
        <PromptResults promptId={promptId} pageRef={pageRef} />
      </div>
    </div>
  );
};
